import { post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getSummaryGenerator = async (payload) => {
  const builder = new UrlBuilder(`/generate-summary`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getZoneDetails = async (payload) => {
  const builder = new UrlBuilder(`/get-zone-details`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
